'use strict';

require("core-js/modules/es.array.reduce");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.default = configureRoutes;

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

if (typeof window !== 'undefined') {
  window.console.table = window.console.table || window.console.log || function () {};
}

var methodDict = {
  create: 'post',
  list: 'get',
  get: 'get',
  update: 'put',
  delete: 'delete',
  search: 'get'
};

var logRoutes = function logRoutes(routes, resource, ns) {
  if (_config2.default.mode === 'development') {
    /* eslint-disable no-console */
    console.groupCollapsed('Rendering Api component for %c' + resource, 'color: green', 'with these routes');
    console.table(Object.keys(routes).reduce(function (memo, key) {
      if (key === 'default') {
        return memo;
      } else {
        var val = typeof routes[key] === 'function' ? routes[key]('id', {}) : routes[key];
        var def = typeof val === 'string' ? {
          method: methodDict[key],
          route: val
        } : val;
        var arg = key === 'get' ? 'id' : '';
        return Object.assign(memo, _defineProperty({}, key, Object.assign(def, _defineProperty({}, 'props.' + ns + '...', key + '(' + arg + ')'))));
      }
    }, {}));
    console.groupEnd();
  }
};

function configureRoutes(key, rootPath) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var main = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var routes = Object.assign({
    create: function create() {
      return {
        method: 'post',
        route: rootPath
      };
    },
    list: function list() {
      return {
        method: 'get',
        route: rootPath
      };
    },
    search: function search() {
      return {
        method: 'get',
        route: rootPath
      };
    },
    get: function get(id) {
      return {
        method: 'get',
        route: rootPath + '/' + id
      };
    },
    update: function update(id) {
      return {
        method: 'put',
        route: rootPath + '/' + id
      };
    },
    delete: function _delete(id) {
      return {
        method: 'delete',
        route: rootPath + '/' + id
      };
    }
  }, options.routes || {});
  logRoutes(routes, rootPath, key);

  var initSuccess = function initSuccess(onSuccess) {
    return function (response) {
      if (onSuccess) {
        if (typeof onSuccess === 'function') {
          var route = Object.entries(routes).find(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                fn = _ref2[1];

            return onSuccess === fn;
          });

          if (route) {
            return main['' + route[0]](response, {
              force: true
            });
          } else {
            return onSuccess(response);
          }
        } else if (onSuccess instanceof Promise) {
          return onSuccess;
        } else if (typeof onSuccess === 'string') {
          return main['' + onSuccess](response, {
            force: true
          });
        }
      } else {
        return response;
      }
    };
  };

  var initError = function initError(onError) {
    return function (err) {
      return onError ? onError(err) : Promise.reject(err);
    };
  };

  return {
    isCustomRoute: function isCustomRoute(key) {
      return !methodDict[key];
    },
    getRouteConfig: function getRouteConfig(methodKey) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var config = routes[methodKey].apply(routes, args);
      return typeof config === 'string' ? {
        method: methodDict[methodKey],
        route: config,
        onSuccess: initSuccess(options.onSuccess || options.getData),
        onError: initError(options.onError)
      } : _extends({}, config, {
        method: (config.method || methodDict[methodKey] || 'get').toLowerCase(),
        route: config.route || routes.default || rootPath,
        // .getData properties are in here for backwards compatibility
        onSuccess: initSuccess(config.onSuccess || options.onSuccess || config.getData || options.getData),
        onError: initError(config.onError || options.onError)
      });
    }
  };
}